import type { SkininiSettings, SkininiColorValue } from "@app-types/skinini.types";

/**
 * Validate color value format
 */
export function isValidColorValue(value: unknown): value is SkininiColorValue {
  if (value === "transparent") return true;
  if (typeof value !== "string") return false;

  return /^rgb\(\d+,\s*\d+,\s*\d+\)$/.test(value);
}

/**
 * Type guard for SkininiSettings
 * Note: This is lenient to allow for extensibility and legacy data
 */
export function isSkininiSettings(data: unknown): data is SkininiSettings {
  if (typeof data !== "object" || data === null) return false;

  const obj = data as Record<string, unknown>;

  // Check known string fields if present
  const stringFields = [
    "Name",
    "Author",
    "Version",
    "HitCirclePrefix",
    "ScorePrefix",
    "ComboPrefix",
  ];
  for (const field of stringFields) {
    if (field in obj && typeof obj[field] !== "string") return false;
  }

  // Check known number fields if present
  const numberFields = [
    "HitCircleOverlap",
    "ScoreOverlap",
    "ComboOverlap",
    "AnimationFramerate",
  ];
  for (const field of numberFields) {
    if (field in obj && typeof obj[field] !== "number") return false;
  }

  // Check boolean fields (stored as 0 or 1) if present
  const boolFields = [
    "CursorExpand",
    "CursorCentre",
    "CursorRotate",
    "CursorTrailRotate",
    "HitCircleOverlayAboveNumber",
    "SliderBallFlip",
    "AllowSliderBallTint",
  ];
  for (const field of boolFields) {
    if (field in obj && obj[field] !== 0 && obj[field] !== 1) return false;
  }

  return true;
}
